export default "__VITE_ASSET__B0qOy3bN__"